import React, { useCallback, useState } from 'react';
import { isMobile } from 'react-device-detect';
import {
  makeStyles,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Tooltip,
  ClickAwayListener,
} from "@material-ui/core";
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import FlagCircleIcon from '@material-ui/icons/FlagRounded';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import InfoIcon from '@material-ui/icons/Info';
import tulumDefaultImage from '../../../assets/tulum-default-image.png';
import stylesCreator from './styles';

const useStyles = makeStyles(stylesCreator);

const LEFT_ARROW_ID = 'left-arrow';
const RIGHT_ARROW_ID = 'right-arrow';

const LiveStreams = ({
  streams,
  onCameraSelect,
  selectedStreamID,
  onFollowTulumFeatured,
  shouldExcludeFeatured,
  isFollowingFeaturedStream,
}) => {
  const classes = useStyles();
  const [scrollableScrolledLeft, setScrollableScrolledLeft] = useState(0);
  const [arrowsVisibility, setArrowsVisibility] = useState({ left: false, right: false });
  const [scrollableNode, setScrollableNode] = useState();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const onRefChanged = useCallback(node => {
    if (node !== null) {
      const left = scrollableScrolledLeft > 0;
      const right = node && node.scrollWidth - node.clientWidth - scrollableScrolledLeft > 3;

      setScrollableNode(node);
      setArrowsVisibility({ left, right });
    }
  }, [scrollableScrolledLeft]);

  const onScrollableScroll = useCallback(event => {
    setScrollableScrolledLeft(event.target.scrollLeft);
  }, []);

  const scrollTo = useCallback(event => {
    let xScrollTo = 0;
    const { id } = event.currentTarget;

    if (id === LEFT_ARROW_ID) {
      xScrollTo = scrollableScrolledLeft - 280;
    }

    if (id === RIGHT_ARROW_ID) {
      xScrollTo = scrollableScrolledLeft + 280;
    }

    scrollableNode.scroll(xScrollTo, 0);
  }, [scrollableScrolledLeft, scrollableNode]);

  const handleChange = useCallback(event => {
    onFollowTulumFeatured(event.target.checked);
  }, []);

  const onCameraSelectHandler = useCallback((streamId, profileUrl) => {
    onFollowTulumFeatured(false);
    onCameraSelect(streamId, profileUrl);
  }, []);

  const handleTooltipClose = useCallback(() => {
    setIsTooltipOpen(false);
  }, []);

  const handleTooltipOpen = useCallback(() => {
    setIsTooltipOpen(true);
  }, []);

  return (
    <Box className={classes.wrapper}>
      {!shouldExcludeFeatured && (
        <Box
          display="flex"
          justifyContent="center"
          mb={2}
          mt={1}
        >
          <Box
            className={classes.featuredStream}
            display="flex"
            alignItems="center"
          >
            <FormControlLabel
              control={(
                <Checkbox
                  checked={isFollowingFeaturedStream}
                  onChange={handleChange}
                  color="primary"
                  classes={{ root: classes.checkbox, checked: classes.checked }}
                />
              )}
              label="Follow Featured Stream"
              classes={{ label: classes.label, root: classes.rootLabel }}
            />
            <ClickAwayListener onClickAway={handleTooltipClose}>
              <Tooltip
                PopperProps={{ disablePortal: true }}
                onClose={handleTooltipClose}
                open={isTooltipOpen}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title="By activating it, you will always have the stream that is featured in the foregrond."
                classes={{
                  tooltip: classes.tooltip
                }}
              >
                <InfoIcon
                  className={classes.infoIcon}
                  onClick={handleTooltipOpen}
                />
              </Tooltip>
            </ClickAwayListener>
          </Box>
        </Box>
      )}
      <Box
        position="relative"
        textAlign="left"
        overflow="hidden"
      >
      <Box
        className={classes.sliderWrapper}
        ref={onRefChanged}
        onScroll={onScrollableScroll}
      >
        <Box
          className={classes.slider}
        >
          {!isMobile && (
            <>
              <Box
                id={LEFT_ARROW_ID}
                className={`${classes.arrow} ${classes.arrowLeft}`}
                onClick={scrollTo}
                style={{ display: `${arrowsVisibility.left ? 'flex' : 'none'}` }}
              >
                <KeyboardArrowLeftIcon className={classes.arrowIcon}/>
              </Box>
              <Box
                id={RIGHT_ARROW_ID}
                className={`${classes.arrow} ${classes.arrowRight}`}
                onClick={scrollTo}
                style={{ display: `${arrowsVisibility.right ? 'flex' : 'none'}` }}
              >
                <KeyboardArrowRightIcon className={classes.arrowIcon}/>
              </Box>
            </>
          )}
        {streams.map(stream => (
          <Box
            className={`${classes.thumbnail} ${stream.id === selectedStreamID ? classes.selected : ''}`}
            style={{
              background: `url(${stream.profileImage ? stream.profileImage : stream.imageUrl}) no-repeat center center / cover, url(${tulumDefaultImage}) no-repeat center center / cover`,
            }}
            onClick={() => onCameraSelectHandler(stream.id, stream.profileUrl)}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {stream.profileUrl && (
              <>
                <Box
                  className={classes.nameWrapper}
                  px={0.5}  
                >
                  <Typography>{stream.name}</Typography>
                </Box>
                <Box className={classes.openInNewIcon}>
                  <OpenInNewIcon/>
                </Box>
              </>
            )}
            {stream.isFeatured && (
              <Box className={classes.flagIcon}>
                <FlagCircleIcon/>
              </Box>
            )}
          </Box>
        ))}
        </Box>
      </Box>
      </Box>
    </Box>
  )
};

export default LiveStreams;
